import Vue from 'vue'
import Router from 'vue-router'


// import HelloWorld from '@/components/HelloWorld'


Vue.use(Router)
const main = resolve => require(['@/views/main.vue'], resolve)
// const login = resolve => require(['@/views/SafetyEducation/login.vue'], resolve)
// const home = resolve => require(['@/views/home/index.vue'], resolve)
// const zfw = resolve => require(['@/views/zfw/index.vue'], resolve)
//新客户端下载页
// const  down= resolve => require(['@/views/wxh5/down.vue'], resolve)
//完善信息页
const index = resolve => require(['@/views/zfw/index.vue'], resolve)
const ditu = resolve => require(['@/components/ditu.vue'], resolve)
const yz = resolve => require(['@/views/zfw/yz.vue'], resolve)
const wfgd = resolve => require(['@/components/wfgd.vue'], resolve)
const nxsp = resolve => require(['@/components/nxsp.vue'], resolve)
const yzdt = resolve => require(['@/views/zfw/yzdt.vue'], resolve)
const nxkx = resolve => require(['@/views/zfw/nxkx.vue'], resolve)
const nxkxxq = resolve => require(['@/views/zfw/nxkxxq.vue'], resolve)
const splb = resolve => require(['@/views/zfw/splb.vue'], resolve)
const spbf = resolve => require(['@/views/zfw/spbf.vue'], resolve)
const nxblist = resolve => require(['@/views/zfw/nxblist.vue'], resolve)
const nxblistxq = resolve => require(['@/views/zfw/nxblistxq.vue'], resolve)
const hdqlist = resolve => require(['@/views/zfw/hdqlist.vue'], resolve)
const hdqlistxq = resolve => require(['@/views/zfw/hdqlistxq.vue'], resolve)
const jkzs = resolve => require(['@/views/zfw/jkzs.vue'], resolve)
const jkzsxq = resolve => require(['@/views/zfw/jkzsxq.vue'], resolve)
// // //首页
const shfw = resolve => require(['@/views/zfw/shfw.vue'], resolve)
const shfwlist = resolve => require(['@/views/zfw/shfwlist.vue'], resolve)
const shfwlistxq = resolve => require(['@/views/zfw/shfwlistxq.vue'], resolve)
const tzlist = resolve => require(['@/views/zfw/tzlist.vue'], resolve)
const tzlistxq = resolve => require(['@/views/zfw/tzlistxq.vue'], resolve)
// const Answer = resolve => require(['@/views/zfw/Answer.vue'], resolve)
// // // 视频播放页
// const Fraction = resolve => require(['@/views/zfw/Fraction.vue'], resolve)
// // // 答题页
// const rankinglist = resolve => require(['@/views/zfw/rankinglist.vue'], resolve)
// // //往期课堂
// const fenx = resolve => require(['@/views/wxh5/fenx.vue'], resolve)
// // //搜索页
// const yqindex = resolve => require(['@/views/wxh5/yqindex.vue'], resolve)
// // //头像上传
// const yqnew = resolve => require(['@/views/wxh5/yqnew.vue'], resolve)
// // //设置页
// const yqpeople = resolve => require(['@/views/wxh5/yqpeople.vue'], resolve)
// const wxnewlist = resolve => require(['@/views/wxh5/wxnewlist.vue'], resolve)
// // //设置页
// const wxpeoplelist = resolve => require(['@/views/wxh5/wxpeoplelist.vue'], resolve)
// //安全知识详情
// const peoplelist1 = resolve => require(['@/views/zfw/peoplelist1.vue'], resolve)
// //答题分数
// const OK = resolve => require(['@/views/SafetyEducation/OK.vue'], resolve)
//新客户邀请页
// const  Invitation= resolve => require(['@/views/wxh5/Invitation.vue'], resolve)
//新客户端建设中
// const  Development= resolve => require(['@/views/newkhd/Development.vue'], resolve)
// // 拉新赚红包页
// const  redStatistics= resolve => require(['@/views/newCustomer/redStatistics.vue'], resolve)
// // 拉新我的奖励页
// const  myReward= resolve => require(['@/views/newCustomer/myReward.vue'], resolve)
// // 提现
// const  outMoney= resolve => require(['@/views/newCustomer/outMoney.vue'], resolve)
// // 排行榜
// const  rankingList= resolve => require(['@/views/newCustomer/rankingList.vue'], resolve)
// // 提现详情
// const  moneyDetails= resolve => require(['@/views/newCustomer/moneyDetails.vue'], resolve)
// // 绑定支付宝
// const  bindingzfb= resolve => require(['@/views/newCustomer/bindingzfb.vue'], resolve)
// // 已绑定支付宝
// const  bingdingedzfb= resolve => require(['@/views/newCustomer/bingdingedzfb.vue'], resolve)
//员工推广页
// const  empindex= resolve => require(['@/views/Employeeinvitations/empindex.vue'], resolve)
// //员工分享推广empInvitation
// const  empInvitation= resolve => require(['@/views/wxh5/empInvitation.vue'], resolve)


// // 地标
// const  dbindex= resolve => require(['@/views/dibiao/dbindex.vue'], resolve)
// //地标列表
// const  dblist= resolve => require(['@/views/dibiao/dblist.vue'], resolve)
// // 地标详情
//
// const  dbdetails= resolve => require(['@/views/dibiao/dbdetails.vue'], resolve)
// // 抽奖
// const  Luckdraw= resolve => require(['@/views/dibiao/Luckdraw.vue'], resolve)
// // 分享
// const  share= resolve => require(['@/views/wxh5/share.vue'], resolve)
// const  share1= resolve => require(['@/views/wxh5/share1.vue'], resolve)
// const  share2= resolve => require(['@/views/wxh5/share2.vue'], resolve)
// // 排行榜
// const  RankingList= resolve => require(['@/views/dibiao/RankingList.vue'], resolve)

var LOGIN_FLAG = true;
export default new Router({
  mode: 'history',
  base: 'nxjjj',
  routes: [
    {
      path: '/',
      name: 'index',
      redirect: '/index'
    },

    {
      path: '/ditu',
      name: 'ditu',
      component: ditu
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/yz',
      name: 'yz',
      component: yz
    },
    {
      path: '/wfgd',
      name: 'wfgd',
      component: wfgd
    },
    {
      path: '/nxsp',
      name: 'nxsp',
      component: nxsp
    },
      {
          path: '/yzdt',
          name: 'yzdt',
          component: yzdt
      },
      {
          path: '/nxkx',
          name: 'nxkx',
          component: nxkx
      },
    {
      path: '/nxkxxq',
      name: 'nxkxxq',
      component: nxkxxq
    },
    {
      path: '/splb',
      name: 'splb',
      component: splb
    },
    {
      path: '/spbf',
      name: 'spbf',
      component: spbf
    },
    {
      path: '/nxblist',
      name: 'nxblist',
      component: nxblist
    },
    {
      path: '/hdqlist',
      name: 'hdqlist',
      component: hdqlist
    },
    {
      path: '/hdqlistxq',
      name: 'hdqlistxq',
      component: hdqlistxq
    },
    {
      path: '/jkzs',
      name: 'jkzs',
      component: jkzs
    },
    {
      path: '/jkzsxq',
      name: 'jkzsxq',
      component: jkzsxq
    },
    {
      path: '/shfw',
      name: 'shfw',
      component: shfw
    },
    {
      path: '/tzlistxq',
      name: 'tzlistxq',
      component: tzlistxq
    },
    {
      path: '/tzlist',
      name: 'tzlist',
      component: tzlist
    },
    {
      path: '/shfwlist',
      name: 'shfwlist',
      component: shfwlist
    },
    {
      path: '/shfwlistxq',
      name: 'shfwlistxq',
      component: shfwlistxq
    },
    {
      path: '/nxblistxq',
      name: 'nxblistxq',
      component: nxblistxq
    },
    // {
    //   path: '/rankingList',
    //   name: 'rankingList',
    //   component: rankingList
    // },
    // {
    //   path: '/moneyDetails',
    //   name: 'moneyDetails',
    //   component: moneyDetails
    // },
    // {
    //   path: '/Invitation',
    //   name: 'Invitation',
    //   component: Invitation
    // },
    // {
    //   path: '/bindingzfb',
    //   name: 'bindingzfb',
    //   component: bindingzfb
    // },
    // {
    //   path: '/bingdingedzfb',
    //   name: 'bingdingedzfb',
    //   component: bingdingedzfb
    // },
    // {
    //   path: '/dbindex',
    //   name: 'dbindex',
    //   component: dbindex
    // },
    // {
    //   path: '/dblist',
    //   name: 'dblist',
    //   component: dblist
    // },


    // {
    //   path: '/zfw',
    //   redirect: 'index',
    //   component: main,
    //   children: [{
    //     path: 'index',
    //     name: '首页',
    //     component: zfw,
    //     // meta: {
    //     // 	tabname: 'home',
    //     // 	keepAlive: true,
    //     // 	requireAuth: false,
    //     // 	allowBack: false
    //     // }
    //   }]
    //
    // },
  ],


})



// WEBPACK FOOTER //
// ./src/router/index.js


// WEBPACK FOOTER //
// ./src/router/index.js